import styles from 'css/ColorDotList.module.css'
import Lib from 'library/'

const ColorDotList = ({ data, colors }) => {
	return (
		<>
			{data &&
				<ul className={`${styles.default} mt_20`}>
					{data.map((item, index) => {
						return (
							<li key={index}>
								<div>
									<i className="colorDot mr_10" style={{ backgroundColor: colors[index] }} />
									<span>{item.key} {item.value}%</span>
								</div>
								<div className={styles.amount}>
									<span>{Lib.addComma(item.amount)}</span> <span>원</span>
									<i className="icon_arrow_right ml_10" />
								</div>
							</li>
						)
					})}
				</ul>
			}
		</>
	)
}

export default ColorDotList
